"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../Button/Button");
var _SocialNetworkLogo = _interopRequireDefault(require("../SocialNetworkLogo/SocialNetworkLogo"));
var _PhoneFormatter = _interopRequireDefault(require("../../common/Formatters/PhoneFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.footer .bx--grid {\n  padding: 0; }\n  .footer .bx--grid .bx--row > div {\n    border-top: 1px solid #d4d4d4;\n    padding-top: 1.5rem;\n    padding-bottom: 1rem; }\n    .footer .bx--grid .bx--row > div.links {\n      padding-top: 1rem; }\n    .footer .bx--grid .bx--row > div.about {\n      padding-left: 1rem; }\n    .footer .bx--grid .bx--row > div p {\n      font-size: 12px;\n      margin-bottom: 1.5rem;\n      color: #4c4c4c; }\n      .footer .bx--grid .bx--row > div p.heading {\n        padding-left: 1rem;\n        font-size: 18px;\n        margin-bottom: 0.5rem; }\n    .footer .bx--grid .bx--row > div a,\n    .footer .bx--grid .bx--row > div button {\n      color: #4c4c4c; }\n    .footer .bx--grid .bx--row > div .bx--btn--ghost {\n      font-size: 14px; }\n";
  const fileName = "Footer_Footer";
  const element = document.querySelector("style[data-sass-component='Footer_Footer']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Footer = props => {
  const renderGhostButton = (rawButton, index) => {
    const href = typeof rawButton.target === 'string' ? rawButton.target : null;
    const onClick = typeof rawButton.target === 'function' ? rawButton.target : null;
    const htmlTarget = Boolean(href) && !rawButton.internal ? rawButton.target[0] === '/' ? null : '_blank' : null;

    // with colon (eg. in an url), strange rewording on translate may happen
    const shouldTranslateHref = href && !href.includes(':');
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      className: "sia-text-10",
      kind: 'ghost',
      size: 'sm',
      href: shouldTranslateHref ? props.translate(href) : href,
      onClick: onClick,
      key: index,
      target: htmlTarget
    }, props.translate(rawButton.label));
  };
  const renderGhostButtonList = rawButtons => rawButtons.map((rawButton, index) => {
    const isLast = rawButtons.length === index + 1;
    const button = renderGhostButton(rawButton, index);
    return !isLast ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, button, /*#__PURE__*/_react.default.createElement("br", null)) : button;
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'footer'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--grid reset-spacings"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-3 bx--col-md-0 bx--col-sm-0"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-6 bx--col-md-4 bx--col-sm-4 follow"
  }, props.follow && Object.entries(props.follow.social).length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: 'heading sia-text-04'
  }, props.translate(props.follow.title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-01-left"
  }, Object.entries(props.follow.social).map(el => {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: el[1],
      hasIconOnly: true,
      kind: 'ghost',
      size: 'sm',
      href: el[1],
      target: '_blank'
    }, /*#__PURE__*/_react.default.createElement(_SocialNetworkLogo.default, {
      socialNewtwork: el[0]?.toLowerCase()
    }));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-5 bx--col-md-4 bx--col-sm-4 contact"
  }, props.contactUs && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
    className: 'heading sia-text-04'
  }, props.translate(props.contactUs.title)), renderGhostButtonList(props.contactUs.buttons))), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-2 bx--col-md-0 bx--col-sm-0"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--row sia-text-06"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-3 bx--col-md-0 bx--col-sm-0"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-6 bx--col-md-4 bx--col-sm-4 links"
  }, props.links && renderGhostButtonList(props.links)), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-5 bx--col-md-4 bx--col-sm-4 about"
  }, props.about && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, props.about.multilanguageSlogan.de, /*#__PURE__*/_react.default.createElement("br", null), props.about.multilanguageSlogan.fr, /*#__PURE__*/_react.default.createElement("br", null), props.about.multilanguageSlogan.it, /*#__PURE__*/_react.default.createElement("br", null), props.about.multilanguageSlogan.en), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: `tel:${props.about.phone}`
  }, _PhoneFormatter.default.format(props.about.phone)), /*#__PURE__*/_react.default.createElement("br", null), props.about.street, /*#__PURE__*/_react.default.createElement("br", null), props.about.zip, " ", props.translate(props.about.cityLabel))), props.customAbout && props.customAbout), /*#__PURE__*/_react.default.createElement("div", {
    className: "bx--col-lg-2 bx--col-md-0 bx--col-sm-0"
  }))));
};
Footer.propTypes = {
  follow: _propTypes.default.object.isRequired,
  contactUs: _propTypes.default.object.isRequired,
  links: _propTypes.default.array.isRequired,
  about: _propTypes.default.object,
  translate: _propTypes.default.func.isRequired
};
var _default = exports.default = Footer;